// Singleton @sympllex/api-client for the partner cockpit. The partner session is
// injected as the dev header; the tenant-worker resolves it into the active-tenant RLS
// context (the firm acts within a mandated tenant). Bearer auth + (firm × tenant) scope
// land with WorkOS browser auth (C1.3) + B3-PARTNER-COCKPIT. PLAN-C1.11.
import { createApiClient, type SympllexApiClient } from "@sympllex/api-client";
import type { SympllexSession } from "@sympllex/auth";
import { API_BASE } from "./env";
import { refreshSession } from "./auth";

let currentSession: SympllexSession | null = null;
export function setApiSession(s: SympllexSession | null): void { currentSession = s; }

export const api: SympllexApiClient = createApiClient({
  baseUrls: API_BASE,
  // prod: rely on the httpOnly session cookie (credentialed CORS). dev: inject the dev-session header.
  mode: import.meta.env.DEV ? "dev" : "cookie",
  getSession: () => currentSession,
  // On a 401 (expired 15-min access token) silently refresh off the 14-day session, then retry once.
  onUnauthorized: refreshSession,
});
